import { Link } from "react-router-dom";
import { Nav } from "./FdServiceList.styled";
import { useSelector } from "react-redux";

const SALES_ANALYSIS_CLIENT_ADDRESS = process.env.REACT_APP_SALES_ANALYSIS_CLIENT_ADDRESS;
const MAIN_CLIENT_ORIGIN = process.env.REACT_APP_MAIN_CLIENT_ADDRESS;

const getMenuHref = (href, workspaceId) => {
    if (href === '/sales-analysis/dashboard') {
        return `${SALES_ANALYSIS_CLIENT_ADDRESS}${href}?workspaceId=${workspaceId}`
    }
    if (!href.includes('https') && href !== '/sales-analysis/dashboard') {
        return `${MAIN_CLIENT_ORIGIN}${href}`
    }
    return href;
}

export function FdServiceList() {
    const workspaceRedux = useSelector(state => state?.workspaceRedux);
    const wsId = workspaceRedux?.workspaceInfo?.id;

    const SERVICE_LIST = [
        // {
        //     href: '/',
        //     name: '셀러툴 홈',
        //     isReady: true,
        //     target: '_self'
        // },
        {
            href: '/margin/dashboard',
            name: '마진율 계산기',
            isReady: true,
            target: '_self'
        },
        {
            href: '/excel-translator',
            name: '엑셀 변환기',
            isReady: true,
            target: '_self'
        },
        {
            href: '/store-rank/real-time-rank',
            name: '스토어 랭킹',
            isReady: true,
            target: '_self'
        },
        {
            href: '/inventory',
            name: '통합 재고 관리',
            isReady: true,
            target: '_self'
        },
        {
            href: `/sales-analysis/dashboard`,
            name: '통합 판매 분석',
            isReady: true,
            target: '_self'
        },
        {
            href: `https://sellertool.notion.site/sellertool/b2533e2649154dae926982488dad3cae`,
            name: '셀러툴 이용 가이드',
            isReady: true,
            target: '_blank'
        }
    ]

    return (
        <>
            <Nav>
                <ul className='main-menu'>
                    {SERVICE_LIST?.map(r => {
                        return (
                            <li key={r?.name} className='menu-item'>
                                <Link
                                    to={getMenuHref(r?.href, wsId)}
                                    target={r?.target}
                                >
                                    <span className='serviceLink' style={{ opacity: !r?.isReady ? 0.7 : '' }}>
                                        {r?.name}
                                        {!r?.isReady &&
                                            <sup>준비중</sup>
                                        }
                                    </span>
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </Nav>
        </>
    );
}